module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-beijing-h5.4506546c.jpg";